import { useConnectedUser } from "../hooks/user.hooks";
import { userIsAdmin } from "../utils";
import SidebarAdmin from "./SidebarAdmin";
import SidebarMember from "./SidebarMember";

function Sidebar() {
	const user = useConnectedUser();

	if (!userIsAdmin(user)) {
		return <SidebarMember></SidebarMember>;
	}
	return <SidebarAdmin></SidebarAdmin>;
}

export default Sidebar;
